// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2H18V4H17V8H23V22H13V15H11V22H1V8H7V4H6V2ZM3 20H7V10H3V20ZM21 10H17V20H21V10ZM13.0039 5.99805H11V8.00195H13.0039V5.99805Z"}}]};

const City13FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-13-filled',
    ref,
    icon: element,
  },
));

City13FilledIcon.displayName = 'City13FilledIcon';

export default City13FilledIcon;
